export const generateSessionId = () => {
    try {
        const sessionId = crypto.randomUUID();
        sessionStorage.setItem("sessionId", sessionId);
        return sessionId
    } catch (error) {
        return "null"
    } 
}